// extracted by mini-css-extract-plugin
module.exports = {"link":"HeadersStyles_link__3SqwE","active":"HeadersStyles_active__k60Ok HeadersStyles_link__3SqwE"};